import {writable} from 'svelte/store';

const API_HOST = (location.hostname === 'localhost' ? 'https://app.miin.ru' : location.origin) + '/api/iem/';
const API_HOST_GC = (location.hostname === 'localhost' ? 'https://app.miin.ru' : location.origin) + '/api/course/';
const API_HOST_INTERNAL = (location.hostname === 'localhost' ? 'https://app.miin.ru' : location.origin) + '/api/';
const API_KEY = 'a6' + '2a' + '-' + '9b' + '80' + '-' + '32' + 'b8' + '-' + 'b1' + '8b';

export const api = async (endpoint, data) => {
    let response = await fetch(API_HOST + endpoint + '?key=' + API_KEY, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: (new URLSearchParams(data)).toString()
    });
    
    return await response.json();
};

export const api_formdata = async (endpoint, formdata) => {
    let response = await fetch(API_HOST + endpoint + '?key=' + API_KEY, {
        method: 'POST',
        body: formdata
    });
    
    return await response.json();
};

export const api_internal = async (endpoint, data) => {
    let response = await fetch(API_HOST_INTERNAL + endpoint + '?key=' + API_KEY + (data ? '&' + (new URLSearchParams(data)).toString() : ''), {
        method: 'GET',
        cache: 'no-cache',
        headers: {
            'Accept': 'application/json',
        }
    });
    
    return await response.json();
}

export const api_getcourse = async (endpoint, data) => {
    let response = await fetch(API_HOST_GC + endpoint, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: (new URLSearchParams(data)).toString()
    });
    
    return await response.json();
};

const STORES = {};

export const store = (name, endpoint = null, value = '{}') => {
    if (STORES[name]) {
        return STORES[name];
    }
    
    let loading = writable(false),
        item = localStorage.getItem(name),
        data = writable(JSON.parse(item ? item : value));
    
    async function load(params) {
        if (endpoint) {
            loading.set(true);
            
            let result = await api(endpoint, params);
            if (result && result.status === '200' && (result.data.length || result.data !== {})) {
                data.set(result.data);
                localStorage.setItem(name, JSON.stringify(result.data));
            } else {
                data.set({});
            }
            loading.set(false);
            
            return result.data;
        }
        
        return false;
    }
    
    function set(params) {
        data.set(params);
        localStorage.setItem(name, JSON.stringify(params));
    }
    
    function remove() {
        data.set('');
        localStorage.removeItem(name);
    }
    
    return STORES[name] = {
        subscribe: data.subscribe,
        set: data.set,
        update: data.update,
        load: load,
        loading: () => loading,
        save: set,
        remove: remove,
    };
};
